// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application }  from "./application"

import PagesController from "./pages_controller"
import SearchGridController from "./search_grid_controller"

application.register("pages", PagesController)
application.register("search-grid", SearchGridController)
